import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Box } from 'core/ui/atoms';

const Tag = ({ text, style = 'default' }) => {
  return (
    style === 'default' ?
      <DefaultStyle>{text}</DefaultStyle> :
      <OutlineStyle>{text}</OutlineStyle>
  );
};

Tag.propTypes = {
  text: PropTypes.string.isRequired,
  style: PropTypes.string,
};

const OutlineStyle = styled(Box)`
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  background: transparent;
  border: 1px solid ${(p) => p.theme.colors.green.light};;
  border-radius: 4px;
  font-size: xx-small;
  font-weight: 400;
  line-height: 1.2;
  text-edge: cap;
  leading-trim: both;
  text-align: center;
  width: fit-content;
  padding: 0px 8px;
  margin: 0;
  align-items: center;
  display: flex;
  text-transform: capitalize;
  white-space: nowrap;
  min-height: 20px;
  height: auto;
`;

const DefaultStyle = styled(Box)`
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  background: ${(p) => p.theme.colors.green.light};
  border-radius: 4px;
  font-size: xx-small;
  font-weight: 400;
  line-height: 1.2;
  text-edge: cap;
  leading-trim: both;
  text-align: center;
  width: fit-content;
  padding: 0px 8px;
  margin: 0;
  align-items: center;
  display: flex;
  text-transform: capitalize;
  white-space: nowrap;
  min-height: 20px;
  height: auto;
`;

export default Tag;
